import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { HISTORY_ACTIONS_KEYS, HISTORY_MUTATIONS_KEYS, SESSION_QUERY_HISTORY_KEY } from '../history.const';
import { HistoryAction, HistoryContext } from '../history.interfaces';

export class LoadSessionQueryHistoryAction implements HistoryAction {
  protected storageService: StorageService;

  actions = {
    [HISTORY_ACTIONS_KEYS.loadSessionQueryHistory]: ({ commit }: HistoryContext): void => {
      this.storageService = this.storageService || container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
      const sessionQueryHistory = this.storageService.getItem<string[]>(SESSION_QUERY_HISTORY_KEY) ?? [];
      commit(HISTORY_MUTATIONS_KEYS.setSessionQueryHistory, sessionQueryHistory);
    }
  };
}
